import React, { Component } from 'react';
import './App.css';
import request from 'request';

class Events extends Component {
  componentDidMount() {
    const baseUrl = 'https://cdn.contentful.com/spaces/j9eel39hrxng/environments/master/entries';
    const qs = {
      access_token: '06711dad040ed332146d711ed15914aa2e8a70d859975a94a89e05bebb19bd35',
      include: 1,
    };
    request({
      uri: baseUrl,
      method: 'GET',
      json: true,
      qs: {
        ...qs,
        content_type: 'event',
        order: '-fields.date',
      },
    }, (err, response, body) => {
      const assetMap = body.includes.Asset.reduce((acc, asset) => {
        return Object.assign(acc, { [asset.sys.id]: asset.fields.file.url });
      }, {});
      this.setState({
        events: body.items.map(item  => {
          const {
            fields: {
              title,
              date,
              image: {
                sys: {
                  id,
                } = {},
              } = {},
            } = {},
          } = item;
          return {
            title,
            date,
            image: assetMap[id],
          };
        }),
      });
    });
  }
  
  render() {
    return (
      <div id="events" className="flex-grid">
      	{
      		this.state && this.state.events.map(event=>{
      			return (
      				<div className="event" key={ event.title }>
      					<img
                  src={ `${event.image}?w=300` || 'http://via.placeholder.com/200x200' }
                  alt=""
                  style={{
                    width: '200px',
                    height: 'auto',
                  }}
                />
                <div>{event.title}</div>
                <div>{ event.date.split('T')[0] }</div>
      				</div>
      			)
      		})
      	}
      </div>
    );
  }
}

export default Events;
